import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Plain http(s) only: affiliate URLs go to window.open() and assistant links
// to <a href>, and neither must ever run a javascript:/data: URL.
export const isHttpUrl = (url) => typeof url === "string" && /^https?:\/\//i.test(url);
